import webuiState from "../app/InternalStateService";
import { extractStorePath } from "../utils/storeUtils";
export const REFRESH_TABLE_REQUEST = "REFRESH_TABLE_REQUEST";
export const REFRESH_TABLE_SUCCESS = "REFRESH_TABLE_SUCCESS";
export const REFRESH_TABLE_FAILURE = "REFRESH_TABLE_FAILURE";

export function triggerRefreshTable(sirenAction, widget, computedBindTo) {
    return (dispatch, getState) => {
        let storePath = extractStorePath(computedBindTo, getState());
        let tableData = getState().getIn(["data", ...storePath, "properties"]);
        tableData = tableData ? tableData.toJS() : {};
        //adding loading animation flags
        //loading animation component should be configured for the same entity to display it
        return dispatch(refreshTable(sirenAction, widget, computedBindTo, storePath, tableData));
    };
}

function refreshTable(sirenAction = {}, widget, computedBindTo, storePath, payload) {
    const triggerLoading = webuiState.getActionByName("loading.triggerLoading");
    // let formData = new FormData();
    // let actionFields = JSON.stringify(sirenAction.fields);
    // formData.append("json", JSON.stringify(payload));
    // if (actionFields) {
    //     formData.append("actionFields", actionFields);
    // }
    // //adding action id to formData
    // if (sirenAction.id) {
    //     formData.append("actionId", sirenAction.id);
    // }
    // //adding action type to formData
    // if (sirenAction.actionType) {
    //     formData.append("action", sirenAction.actionType);
    // }

    let jsonData = {
        action: {
            id: sirenAction.id,
            actionType: sirenAction.actionType,
            parameters: sirenAction.parameters
        },
        content: payload
    };

    return async (dispatch, getState) => {
        let endpoint =
            sirenAction.href ||
            webuiState.getActionByName("widget.getWidgetUrl")(widget, getState());
        let actionResult;
        try {
            await dispatch({
                type: REFRESH_TABLE_REQUEST
            });
            await dispatch(triggerLoading([computedBindTo], computedBindTo, true));
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "POST",
                        endpoint: endpoint,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: jsonData
                    },
                    {
                        widgetId: widget
                    }
                )
            );
            dispatch({
                type: REFRESH_TABLE_SUCCESS,
                payload: {
                    data: actionResult,
                    widget: widget,
                    path: storePath
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            dispatch({
                type: REFRESH_TABLE_FAILURE
            });
        } finally {
            dispatch(triggerLoading([computedBindTo], computedBindTo, false));
        }
        return actionResult;
    };
}
